import axios from 'axios';

export const api = axios.create({
    baseURL: 'https://hellopandamix.com/wp-json/wp/v2/',
    // baseURL: 'https://panda.nyoweb.com/wp-json/wp/v2/',
    headers: {
        'Cache-Control': 'no-cache',
    }
});

export const mail = axios.create({
    baseURL: 'https://hellopandamix.com/wp-json/mail/v1/',
    // baseURL: 'https://panda.nyoweb.com/wp-json/mail/v1/',
})